// extracted by mini-css-extract-plugin
export default {"flex-center":"event-date_flex-center__PPSUN","flex-vertical-center":"event-date_flex-vertical-center__27--a","date":"event-date_date__p7ASp"};